import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Asset } from '@api/model/asset';
import { map, Observable } from 'rxjs';
import { AssetSelectedState } from '../../../../asset-details/asset-selected-state/asset-selected.state';
import { ComponentBaseDirective } from '../../component.base';
import { RoleMenu } from './roleMenu';

@Component({
    selector: 'app-role-menu-select',
    templateUrl: './role-menu-select.component.html',
    standalone: false,
})
export class RoleMenuSelectComponent extends ComponentBaseDirective {
    private lastRole: string;

    @Input() public selectedRole: string;
    @Output() public selectedRoleChange = new EventEmitter<string>();
    public asset$: Observable<Asset> = this.store.select(AssetSelectedState.getAsset);
    public RoleMenus$ = this.translationService.afterLanguageChanged$.pipe(
        map(() => {
            return RoleMenu.map((roleMenu) => {
                return { ...roleMenu, name: this.translationService.translate(roleMenu.name) };
            });
        })
    );

    public emitSelect(selectedRole: string) {
        if (this.lastRole === selectedRole) {
            return;
        }

        this.lastRole = selectedRole;
        this.selectedRoleChange.emit(selectedRole);
    }
}
